import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from '../Store';
import Routes from './routes';
import 'intersection-observer';

export const { store, persistor } = configureStore();

const AppRoute = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Routes />
      {/* <div style={{alignItems:'center',justifyContent:'center',display:'flex',flexDirection:'column ', height: "50vh"}}>
                <div style={{backgroundColor:'white',alignItems:'center',justifyContent:'center',display:'flex',flexDirection:'column',padding:20,borderRadius:10}}>
                    <span className="fs-18 weight-600">Maintenance Mode</span>
                    <span style={{padding:10}}>We got to show you something really cool! We will be back shortly.</span>
                    <span>Thanks for your patience!</span>
                </div>
            </div> */}
    </PersistGate>
  </Provider>
);

export default AppRoute;
